import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Cesium from "cesium";
import { Viewer, Entity, PolygonGraphics } from "resium";
import RegulatorOperationContentModal from "./RegulatorOperationContentModal";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Static_modal from "../user/etc/Static_modal";
import Modal from "react-bootstrap/Modal";
import AuthService from "../../services/auth.service";
import RegulatorService from "../../services/regulator.service";


import * as turf from "@turf/turf";


//// prime react 
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import './prime_edit.css'

//Steps
import Regulator_Status from '../../Style_Component/Steps/Regulator_Drone_Status'
import Plan_Status from '../../Style_Component/Steps/Plan_Status'

//icon
import { MdDateRange } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaUserAstronaut } from "react-icons/fa";
import { GiDeliveryDrone } from "react-icons/gi";
import { PiIdentificationBadgeDuotone } from "react-icons/pi";
import docgif from "../../picture/search.gif";
export default function CaatOperationStatus() {
  const [showRegulatorOperationModal, setShowRegulatorOperationModal] =
    useState(false);
  const handleToggleRegulatorOperationModal = () => {
    setShowRegulatorOperationModal(!showRegulatorOperationModal);
  };


  const [loading, setLoading] = useState(false);
  const mapRef = useRef(null);
  const [allArea, setAllArea] = useState({});
  const [showInfomation, setShowInfomation] = useState(false);
  const [showInfomation2, setShowInfomation2] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [operationid, setOperationid] = useState("");
  const [dataupdate, setdataupdate] = useState("");
  const [waitstatus3, setWaitstatus3] = useState("");
  const [itemsA, setItemsA] = useState([]);
  const [itemsB, setItemsB] = useState([]);
  const [items, setItems] = useState([]);
  const [droneArray, setdroneArray] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [target, setTarget] = useState(null);
  const [valuetool, setValuetool] = useState();
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleClick = (event) => {
    setShowTooltip(!showTooltip);
    setTarget(event.target);
    setValuetool(event.target.value);
  };
  const updateOperation = (operation_id) => {
    let operationupdate = RegulatorService.AuthorizedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        setShowInfomation(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const Neverauthorized = (operation_id) => {
    let operationupdate = RegulatorService.DeniedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        setShowInfomation(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const Rescindedoperation = (operation_id) => {
    let operationupdate = RegulatorService.RescindedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        setShowInfomation(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const getOperation = () => {
    let operationlist = RegulatorService.Opearationdata();
    if (operationlist != null) {
      operationlist.then((response) => {
        const tempArray = [];
        const tempArray2 = [];
        for (
          let operationCount = 0;
          operationCount < response.data.operator_data.length;
          operationCount++
        ) {
          tempArray.push(response.data.operator_data[operationCount]);
        }
        for (
          let operationCount = 0;
          operationCount < response.data.agency_data.length;
          operationCount++
        ) {
          tempArray2.push(response.data.agency_data[operationCount]);
        }
        setItemsA(tempArray.reverse());
        setItemsB(tempArray2.reverse());
        setLoading(true);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };

  const [selectedInformation, setSelectedInformation] = useState([]);
  const [showApproveDroneList, setShowAprroveDroneList] = useState(false);
  const [showUnApproveDroneList, setShowUnAprroveDroneList] = useState(false);

  const handleClose = () => {
    setShowAprroveDroneList(false);
    setShowUnAprroveDroneList(false);
    setdroneArray([]);
    setShowInfomation(false);
    setShowInfomation2(false);
    setChosenTable(1);
    setShowNoData(false);
    // window.location.reload(false);
  };

  const handleShowInformation = () => {
    setShowInfomation(true);
    setChosenTable(2);
  };

  const updateCoopData = () => {
    let operationlist = AuthService.updateco(
      dataupdate,
      selectedInformation[0],
      selectedInformation[1]
    );
    operationlist.then((response) => {
      setShowUnAprroveDroneList(false);
      window.location.reload(false);
      //setdroneArray(response.data)
    });
  };

  useEffect(() => {
    getOperation();
    //droneCoopData();
  }, []);

  const [chosenTable, setChosenTable] = useState(1);
  const [itemsPerPage] = useState(4);
  const [searchTermA, setSearchTermA] = useState("");
  const [searchTermB, setSearchTermB] = useState("");
  const handleSearchA = (event) => {
    setSearchTermA(event.target.value);
    setCurrentPageA(0);
  };

  const filteredDataA = itemsA.filter((item) => {
    return (
      item.operation_id
        .toString()
        .toLowerCase()
        .includes(searchTermA.toLowerCase()) ||
      item.id.toLowerCase().includes(searchTermA.toLowerCase())
      // ||
      // item.operation_start_time
      //   .toLowerCase()
      //   .includes(searchTermA.toLowerCase()) ||
      // item.operation_end_time.toLowerCase().includes(searchTermA.toLowerCase())
    );
  });

  const filteredDataB = itemsB.filter((item) => {
    return (
      item.operation_id
        .toString()
        .toLowerCase()
        .includes(searchTermB.toLowerCase()) ||
      item.id.toString().toLowerCase().includes(searchTermB.toLowerCase())
      // ||
      // item.operation_start_time
      //   .toLowerCase()
      //   .includes(searchTermB.toLowerCase()) ||
      // item.operation_end_time.toLowerCase().includes(searchTermB.toLowerCase())
    );
  });

  const [currentPageA, setCurrentPageA] = useState(0);
  const startIndexA = currentPageA * itemsPerPage;
  const endIndexA = startIndexA + itemsPerPage;
  const currentItemsA = filteredDataA.slice(startIndexA, endIndexA);
  const handlePageChangeA = (page) => {
    if (page >= 0) setCurrentPageA(page);
  };

  const [currentPageB, setCurrentPageB] = useState(0);

  const handlePageChangeB = (page) => {
    if (page >= 0) setCurrentPageB(page);
  };

  const [currentDronePage, setCurrentDronePage] = useState(0);
  const startDronePageIndex = currentDronePage * itemsPerPage;
  const endDronePageIndex = startDronePageIndex + itemsPerPage;
  const currentDroneItems = droneArray.slice(
    startDronePageIndex,
    endDronePageIndex
  );
  const handleDronePageChange = (page) => {
    if (page >= 0) setCurrentDronePage(page);
  };

  const [approvedItems, setApprovedItems] = useState([]);
  const [unApprovedItems, setUnApprovedItems] = useState([]);

  const [currentApprovedPage, setCurrentAprrovedPage] = useState(0);
  const startApprovedIndex = currentApprovedPage * itemsPerPage;
  const endApprovedIndex = startApprovedIndex + itemsPerPage;
  // const currentAprrovedItems = filteredApproveData.slice(
  //   startApprovedIndex,
  //   endApprovedIndex
  // );
  const handlePageAprovedChange = (page) => {
    if (page >= 0) setCurrentAprrovedPage(page);
  };

  const [currentUnApprovedPage, setCurrentUnAprrovedPage] = useState(0);
  const startUnApprovedIndex = currentUnApprovedPage * itemsPerPage;
  const endUnApprovedIndex = startUnApprovedIndex + itemsPerPage;
  // const currentUnAprrovedItems = filteredUnApproveData.slice(
  //   startUnApprovedIndex,
  //   endUnApprovedIndex
  // );
  const handlePageUnAprovedChange = (page) => {
    if (page >= 0) setCurrentUnAprrovedPage(page);
  };

  function formatDate(input) {
    // Parse the date string to create a new Date object
    const date = new Date(input);

    // Extract day, month, year, hours, and minutes
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    // Return the formatted date
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  ///pagination param
  const [searchValues, setSeachValue] = useState(["id"]);
  const [portionData, setPortionData] = useState([]);
  const [startArr, setStartArr] = useState(0);
  const handlePortionChange = (newPortion, startarr) => {
    setPortionData(newPortion);
    setStartArr(startarr);
  };

  function center_Polygon(area) {
    let polygon = turf.polygon([area]);
    let centroid = turf.centroid(polygon);

    return centroid; //return Geojson Form {tpye,props,geometry:{type,coordinates}}
  }

  /////////Prime 
  const [globalFilter, setGlobalFilter] = useState(null);
  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0"> </h4>
        <IconField iconPosition="left">
          <InputText style={{ width: "auto" }} value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="🔍  ค้นหา..." />
        </IconField>
      </div>

    );
  };
  const header = renderHeader();

  const Body_Opeation_ID = (item) => {
    return (
      <>
  
        <Button
          onClick={(e) => handleClick(e)}
          value={item.id}
          style={{
            background: "none",
            border: "none",
            color: "#575757",
            textAlign:"start"
          }}
        >
          <PiIdentificationBadgeDuotone style={{marginBottom:"2px",marginRight:"1px"}}/>
          {item.id.substring(0, 13)}...
        </Button>
        <Overlay
          show={showTooltip}
          target={target}
          placement="top"
          container={document.body}
          containerPadding={20}
        >
          <Tooltip id="tooltip">{valuetool}</Tooltip>
        </Overlay>
      </>
    );
  }
  const Body_owner_brand = (item) => {
    return (
      <div style={{ justifyContent: "center", alignItems: "center" }}>
        <div style={{ textAlign: "left" }}>
          <FaUserAstronaut style={{marginBottom:"5px"}}/>  {item.pilot_name}
          <br />
          <GiDeliveryDrone style={{marginBottom:"5px"}}/> {item.drone_model}
        </div>

      </div>);

  }
  const Body_Start_Time = (item) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <MdDateRange />
          <div style={{ marginLeft: "2px" }}>   {`${item.start_time.substring(0, 10)}` + " " + `${item.start_time.substring(11, 16)}`}</div>
        </div>
        <div>{item.operation_type}</div>
      </>

    );
  }
  const Body_Stop_Time = (item) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <MdDateRange />
          <div style={{ marginLeft: "2px" }}>   {`${item.end_time.substring(0, 10)}` + " " + `${item.end_time.substring(11, 16)}`}</div>
        </div>
        <div>{item.operation_type}</div>
      </>

    );
  }
  const Body_Status = (item) => {
    return (
      <Plan_Status status={item.operation_status_name} />
    );
  }
  const Body_Information = (item) => {
    return (
      <div>
        <p style={{ cursor: "pointer", fontSize: "25px" ,margin:"0px"}}
        className="investigate-button"
        onClick={() => {
          setShowRegulatorOperationModal(true);
          setSelectedInformation([
            item.id,
            item.operation_type,
            item.start_time,
            item.end_time,
            item.operation_area.Volume3D.outline_polygon
              .vertices,
            item.operation_area.Volume3D.altitude,
            item.pilot_name,
            item.drone_model,
            item.purpose,
            item.operation_id,
            item.operation_status,
            item.operation_file,
            item.purpose_etc
          ]);

          console.log("Selected : ", item);
          handleShowInformation();
          setAllArea([
            item.operation_area.Volume3D.outline_polygon
              .vertices,
            item.operation_area.Volume3D.altitude,
            item.pilot_name,
            item.drone_model,
            item.purpose,
            item.operation_id,
            item.operation_status
          ])
        }}>
          <img alt="checkdata" src={docgif} style={{height:"37px"}}/>
        </p>
      </div>
      // <FaRegEdit
      //   style={{ cursor: "pointer", fontSize: "25px" }}
      //   className="investigate-button"
      //   onClick={() => {
      //     setShowRegulatorOperationModal(true);
      //     setSelectedInformation([
      //       item.id,
      //       item.operation_type,
      //       item.start_time,
      //       item.end_time,
      //       item.operation_area.Volume3D.outline_polygon
      //         .vertices,
      //       item.operation_area.Volume3D.altitude,
      //       item.pilot_name,
      //       item.drone_model,
      //       item.purpose,
      //       item.operation_id,
      //       item.operation_status
      //     ]);

      //     console.log("Selected : ", item);
      //     handleShowInformation();
      //     setAllArea([
      //       item.operation_area.Volume3D.outline_polygon
      //         .vertices,
      //       item.operation_area.Volume3D.altitude,
      //       item.pilot_name,
      //       item.drone_model,
      //       item.purpose,
      //       item.operation_id,
      //       item.operation_status
      //     ])
      //   }}
      // />
    );
  }

  ///sort && filter
  const sortOrder = ["ยื่นคำขอ", "อนุมัติ", "เสร็จภารกิจ", "ภารกิจถูกยกเลิก", "หน่วยงานยกเลิกภารกิจ", "ไม่อนุมัติ"];
  const customSort = (event) => {
    const value = [...event.data]; // Clone the array to avoid modifying the original data
    value.sort((a, b) => {
      const value1 = a[event.field];
      const value2 = b[event.field];

      const index1 = sortOrder.indexOf(value1);
      const index2 = sortOrder.indexOf(value2);

      return (index1 - index2) * event.order;
    });
    return value;
  };
  function filtered(data) {
    const filteredData = data.filter(item =>
      item.id.toLowerCase().split(" ").join("").includes(globalFilter.toLowerCase().split(" ").join("")) ||
      item.start_time.toLowerCase().split(" ").join("").includes(globalFilter.toLowerCase().split(" ").join("")) ||
      item.end_time.toLowerCase().split(" ").join("").includes(globalFilter.toLowerCase().split(" ").join("")) ||
      item.operation_status_name.toLowerCase().split(" ").join("").includes(globalFilter.toLowerCase().split(" ").join(""))
    );
    console.log(filteredData);
    return filteredData
  }
  console.log(itemsA);
  return (
    <div>
      {showRegulatorOperationModal && (
        <RegulatorOperationContentModal
          toggleModal={showRegulatorOperationModal}
          onHide={handleToggleRegulatorOperationModal}
          content={{
            id: selectedInformation[0],
            type: selectedInformation[1],
            start: selectedInformation[2],
            end: selectedInformation[3],
            positions: selectedInformation[4],
            height: selectedInformation[5],
            pilot_name: selectedInformation[6],
            drone_model: selectedInformation[7],
            purpose: selectedInformation[8],
            operation_id: selectedInformation[9],
            status: selectedInformation[10],
            file: selectedInformation[11],
            purpose_etc: selectedInformation[12]
          }}
        />
      )}
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      {showApproveDroneList === true && (
        <Modal
          show={showApproveDroneList}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              โดรนที่เข้าร่วมรหัส {selectedInformation[1]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div style={{ height: "400px" }}>
              <table style={{ marginLeft: "auto", marginRight: "auto" }}>
                <thead>
                  <tr>
                    <th className="table-space" style={{ width: "10%" }}>
                      ลำดับ
                    </th>
                    <th className="table-space">รหัสการปฏิบัติการ</th>
                    <th className="table-space">โมเดลของโดรน</th>
                    <th className="table-space">เวลาเริ่มภารกิจ</th>
                  </tr>
                </thead>
                <tbody>
                  {currentDroneItems.map((item) => (
                    <tr key={item.id}>
                      <td className="table-space">{item.user_id}</td>
                      <td className="table-space">{item.name}</td>
                      <td className="table-space">{item.brand_model}</td>
                      <td className="table-space">{item.created_at}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ marginRight: "0px", marginBottom: "10px" }}>
              <div className="page-changer-container">
                {currentDronePage !== 0 && (
                  <button
                    onClick={() => handleDronePageChange(currentDronePage - 1)}
                  >
                    {currentDronePage}
                  </button>
                )}
                {currentDronePage !==
                  Math.ceil(droneArray.length / itemsPerPage) - 1 && (
                    <button
                      onClick={() => handleDronePageChange(currentDronePage + 1)}
                    >
                      {currentDronePage + 2}
                    </button>
                  )}
                {currentDronePage <
                  Math.ceil(droneArray.length / itemsPerPage) - 2 && (
                    <div style={{ display: "flex" }}>
                      <h3>......</h3>
                      <button
                        onClick={() =>
                          handleDronePageChange(
                            Math.ceil(droneArray.length / itemsPerPage) - 1
                          )
                        }
                      >
                        {Math.ceil(droneArray.length / itemsPerPage)}
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                }}
              ></div>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {showUnApproveDroneList === true && (
        <Modal
          show={showUnApproveDroneList}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              โดรนที่เข้าร่วมรหัส {selectedInformation[1]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div style={{ height: "400px" }}>
              <table style={{ marginLeft: "auto", marginRight: "auto" }}>
                <thead>
                  <tr>
                    <th className="table-space" style={{ width: "10%" }}>
                      ลำดับ
                    </th>
                    <th className="table-space">ชื่อนักบิน</th>
                    <th className="table-space">โมเดลของโดรน</th>
                    <th className="table-space">เวลาที่ขออนุญาต</th>
                    <th className="table-space">ยืนยินการขออนุญาต</th>
                  </tr>
                </thead>
                <tbody>
                  {currentDroneItems.map((item) => (
                    <tr key={item.id}>
                      <td className="table-space">{item.user_id}</td>
                      <td className="table-space">{item.name}</td>
                      <td className="table-space">{item.brand_model}</td>
                      <td className="table-space">{item.created_at}</td>
                      <td className="table-space">
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          {waitstatus3 ? (
                            <div
                              style={{
                                backgroundColor: "yellow",
                                width: "90%",
                                margin: "0px auto",
                                color: "black",
                                borderRadius: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                updateCoopData();
                              }}
                            >
                              รอหน่วยงานอนุมัติ
                            </div>
                          ) : (
                            <>
                              <div
                                style={{
                                  backgroundColor: "green",
                                  width: "40%",
                                  margin: "0px auto",
                                  color: "white",
                                  borderRadius: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  updateCoopData();
                                }}
                              >
                                อนุมัติ
                              </div>
                              <div
                                style={{
                                  backgroundColor: "#FF0000",
                                  width: "40%",
                                  margin: "0px auto",
                                  color: "white",
                                  borderRadius: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => { }}
                              >
                                ไม่อนุมัติ
                              </div>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ marginRight: "0px", marginBottom: "10px" }}>
              <div className="page-changer-container">
                {currentDronePage !== 0 && (
                  <button
                    onClick={() => handleDronePageChange(currentDronePage - 1)}
                  >
                    {currentDronePage}
                  </button>
                )}
                {currentDronePage !==
                  Math.ceil(droneArray.length / itemsPerPage) - 1 && (
                    <button
                      onClick={() => handleDronePageChange(currentDronePage + 1)}
                    >
                      {currentDronePage + 2}
                    </button>
                  )}
                {currentDronePage <
                  Math.ceil(droneArray.length / itemsPerPage) - 2 && (
                    <div style={{ display: "flex" }}>
                      <h3>......</h3>
                      <button
                        onClick={() =>
                          handleDronePageChange(
                            Math.ceil(droneArray.length / itemsPerPage) - 1
                          )
                        }
                      >
                        {Math.ceil(droneArray.length / itemsPerPage)}
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                }}
              ></div>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {showNoData === true && (
        <Modal
          show={showNoData}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              แจ้งเตือน
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div
              style={{
                display: "flex",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h1>ไม่มีข้อมูล</h1>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}></div>
          </Modal.Footer>
        </Modal>
      )}


      <div
        className="container-main"
        style={{ width: "90%", marginLeft: "5%" }}
      >
        <div className="table-card-header" style={{ color: "white", background: "linear-gradient(90deg, #b1bcc4b5 0%, #edf3f5 100%)" }}>
          <h4 className="header-main" style={{ color: "rgb(78 85 90)" }}>
            รายการปฏิบัติการ
          </h4>
        </div>
        <div style={{ textAlign: "end", marginTop: "35px" }}>
          <p>จำนวน {itemsA.length} รายการ</p>
        </div>

        <DataTable value={globalFilter ? filtered(itemsA) : itemsA}
          paginator
          
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          rows={5}
          rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
          header={header}
          emptyMessage="ไม่พบข้อมูล"
          tableStyle={{ minWidth: '50rem' }}
          style={{ fontFamily: "Kanit" }}
        >
          <Column header="รหัสปฏิบัติการ"
            body={Body_Opeation_ID}  
            field={`id`}
            sortable
            filterField="id"
            dataType="date"
            bodyStyle={{ alignItems: "center", textAlign: 'start' }}
            style={{ width: '12%' }}
          ></Column>

          <Column header="ผู้ถือครอง / แบรนด์-รุ่น"
            body={Body_owner_brand}
            field="pilot_name"
            sortable

            bodyStyle={{ alignItems: "center", textAlign: 'center' }}
            style={{ width: '17%' }}
          ></Column>

          <Column header={`เวลาเริ่มภารกิจ`}
            body={Body_Start_Time}
            field={"start_time"}
            sortable
            bodyStyle={{ alignItems: "center", textAlign: 'center' }}
            style={{ width: '16%' }}>
          </Column>

          <Column header="เวลาสิ้นสุดภารกิจ"
            body={Body_Stop_Time}
            field="end_time"
            sortable

            bodyStyle={{ textAlign: 'center' }}
            style={{ width: '16%' }} >
          </Column>

          <Column header="สถานะ"
            body={Body_Status}
            sortFunction={customSort}
            field="operation_status_name"
            sortable
            bodyStyle={{ textAlign: 'center' }}
            style={{ width: '7%' }}
          ></Column>

          <Column header="ตรวจสอบข้อมูล"
            body={Body_Information}
            field="operation_status_name"
            sortable
            sortFunction={customSort}
            bodyStyle={{ textAlign: 'center' }}
            style={{ width: '12%' }}
       
          ></Column>

        </DataTable>


      </div>
    </div>
  );
};
